<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Modules</span>
    <span slot="breadcrumbs">
      <router-link :to="{name: 'client-modules'}">
        <i class="fas fa-exchange-alt"></i> Switch to User View
      </router-link>
    </span>
    <b-tabs card no-fade @input="resetForm">
      <b-tab title="All" active>
        <all/>
      </b-tab>
      <b-tab title="Archived">
        <archived/>
      </b-tab>
      <b-tab title="<i class='fas fa-plus'></i> Add">
        <add ref="add"/>
      </b-tab>
    </b-tabs>

    <b-modal
      v-model="showMediaLibrary"
      title="Media Library"
      centered hide-footer
      size="lg">
      <media-table
        v-if="showMediaLibrary"
        :view="mediaView"
        :show-type-select="false"
        :show-module-select="false"
        context="selectOne"
        type="image"
        @selectMedia="setImageID"/>
    </b-modal>

    <b-modal v-model="showMediaModal"
             :title="selectedImageName"
             centered 
             hide-footer
             size="lg">
      <b-img :src="selectedImageSrc" />
    </b-modal>
  </page>
</template>

<script>
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import all from './all'
import add from './add'
import archived from './archived'

export default {
  components: {
    add,
    all,
    archived,
    sidebar,
    page
  },
  methods: {
    resetForm (e) {
      if (!this.$refs.add.saving) {
        this.$refs.add.resetForm()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/modules/index.vue